import {
  ACCOUNT_DELETION_ROUTE, SERVICE_AGREEMENT_ROUTE, ACH_AUTHORIZATION_ROUTE,
  DASHBOARD_ROUTE, SITEMAP_APPROVAL_ROUTE, SITEMAP_SUBMITTED_ROUTE,
} from './RouteConstants';

export const VERSION = '2026.3.7.0.0';

export const MAIN_CONTENT_ID = 'main';
export const ENV = process.env.REACT_APP_ENV;
export const HOST_URL = process.env.REACT_APP_HOST_URL;
export const LEGACY_PORTAL_URL = process.env.REACT_APP_LEGACY_PORTAL;
export const CRYPTO_KEY = `${process.env.REACT_APP_KEY}`;
export const CRYPTO_IV = `${process.env.REACT_APP_INITIALIZATION_VECTOR}`;
export const IMAGE_PATH_URL = process.env.REACT_APP_IMAGE_PATH_URL;
export const SERVICE_REQUEST_FORM_URL = process.env.REACT_APP_SERVICE_REQUEST_FORM;
export const VIEWPOINT_URL = process.env.REACT_APP_VIEWPOINT_URL;
export const ONBOARDING_URL = process.env.REACT_APP_ONBOARDING_URL;
export const REDIRECT_EXCEPTION_ORG_IDS = process.env.REACT_APP_REDIRECT_EXCEPTION_ORG_IDS?.split(',').map(Number) || [];

export const TRANSLATE_FILE_PATH = `${HOST_URL}/locales/{{lng}}/{{ns}}.json`;
export const IMAGE_FILES_PATH = `${IMAGE_PATH_URL}/img`;
export const EV_IMAGE_FILES_PATH = `${IMAGE_PATH_URL}/evimages`;
export const JS_FILES_PATH = `${IMAGE_PATH_URL}/js`;

export const MOCK_SERVER_URI = process.env.REACT_APP_MOCK_SERVER_URI;
export const ORCHESTRATION_SERVICE_API = `${process.env.REACT_APP_API_URL}/ecomm-orchestration-service`;
export const OKTA_URL = process.env.REACT_APP_OKTA_URL;
export const CYBERSOURCE_API = process.env.REACT_APP_CYBERSOURCE_API;
export const VIEWPOINT_API = `${process.env.REACT_APP_API_URL}/viewpoint-service`;
export const ACCOUNT_MANAGEMENT_API = `${process.env.REACT_APP_API_URL}/account-management`;
export const ENTITLEMENTS_API = `${process.env.REACT_APP_API_URL}/entitlements`;

export const AUTH_SERVICE_ENDPOINT = `${process.env.REACT_APP_AUTH_SERVICE_URL}/v1`;
// #genai auth-service OAuth2 login endpoint used to hand off to EVONE (Horizon) via redirectURI + clientID
export const AUTH_OAUTH2_LOGIN_API = `${AUTH_SERVICE_ENDPOINT}/oauth2/login`;
export const EVONE_CLIENT_ID = process.env.REACT_APP_EVONE_CLIENT_ID || '';
export const EVONE_APP_CODE = 'EVONE';

export const KEY = process.env.REACT_APP_KEY;
export const INITIALIZATION_VECTOR = process.env.REACT_APP_INITIALIZATION_VECTOR;
export const OKTA_LOGOUT_URL = `${OKTA_URL.substring(0, OKTA_URL.lastIndexOf('/'))}/logout`;
export const LOCAL_STORAGE_ITEMS = ['token', 'ev_ud', 'ev_mgc'];
export const SESSION_STORAGE_ITEMS = ['token', 'ev_ud'];

export const TYPE_AHEAD_API = `${ORCHESTRATION_SERVICE_API}/v1/typeahead`;
export const GEOCODE_API = `${ORCHESTRATION_SERVICE_API}/v1/forward`;
export const REVERSE_GEOCODE_API = `${ORCHESTRATION_SERVICE_API}/v1/reverse`;

export const INIT_PARAMETERS_API = `${ORCHESTRATION_SERVICE_API}/v1/init-parameters`;
export const USER_PRODUCTS_API = `${ORCHESTRATION_SERVICE_API}/v1/products`;
export const GET_ESTIMATED_COST_API = `${ORCHESTRATION_SERVICE_API}/v1/estimated-cost`;
export const PLACE_ORDER_API = `${ORCHESTRATION_SERVICE_API}/v1/place-order`;
export const CONTROL_STATES_API = `${ORCHESTRATION_SERVICE_API}/v1/user/:userId/control-states`;
export const BILL_PAYER_INFO_API = `${ORCHESTRATION_SERVICE_API}/v1/bill-payer-info`;
export const BANK_ACCOUNT_INFO_API = `${ORCHESTRATION_SERVICE_API}/v1/bank-account-info`; // #genai
// #genai Phase 2 multi-payment-methods endpoints (gated by ENABLE_MULTI_PAYMENT_METHODS server-side).
export const PAYMENT_METHODS_API = `${ORCHESTRATION_SERVICE_API}/v1/payment-methods`;
export const paymentMethodDefaultApi = (type, id) => `${PAYMENT_METHODS_API}/${type}/${id}/default`;
export const paymentMethodRemoveApi = (type, id) => `${PAYMENT_METHODS_API}/${type}/${id}/remove`;
export const KEYS_PROVIDER_API = `${ORCHESTRATION_SERVICE_API}/v1/keys-provider`;
export const CARD_VALIDATE_API = `${CYBERSOURCE_API}/flex/v1/tokens`;
export const ADD_ON_COMPATIBILITY_API = `${ORCHESTRATION_SERVICE_API}/v1/addon-compatibility`;
export const VALIDATOR_FIELDS_API = `${ORCHESTRATION_SERVICE_API}/v1/user/:userId/validator-fields`;

export const GET_SOLAR_PRODUCTS_AVAILABILITY_API = `${ORCHESTRATION_SERVICE_API}/v1/solar-products-availability`;

export const ORDER_HISTORY_REPORT_IDS_API = `${ORCHESTRATION_SERVICE_API}/v1/report-ids`;
export const ORDER_HISTORY_REPORT_DETAILS_API = `${ORCHESTRATION_SERVICE_API}/v1/order-history`;
export const ORDER_HISTORY_REPORT_FILE_TYPES_API = `${ORCHESTRATION_SERVICE_API}/v1/file-types`;
export const DOWNLOAD_ORDER_HISTORY_EXCEL = `${ORCHESTRATION_SERVICE_API}/v1/download-excel`;
export const ORDER_CLOSURE_REASONS = `${ORCHESTRATION_SERVICE_API}/v1/status-reasons`;
export const EMAIL_REPORT_FILES_API = `${ORCHESTRATION_SERVICE_API}/v1/email`;
export const CANCEL_ORDER_API = `${ORCHESTRATION_SERVICE_API}/v1/cancel-order`;
export const AVAILABLE_REPORT_ACTIONS_API = `${ORCHESTRATION_SERVICE_API}/v1/reports/available-actions`;
export const DOWNLOAD_REPORT_FILES_API = `${ORCHESTRATION_SERVICE_API}/v1/download`;
export const ORDER_PREFERENCES_API = `${ORCHESTRATION_SERVICE_API}/v1/order-preferences`;
export const GET_ORDER_PREFERENCES_API = `${ORCHESTRATION_SERVICE_API}/v1/user/:userId/order-preferences`;
export const REPORT_ADDRESSES_API = `${ORCHESTRATION_SERVICE_API}/v1/report-addresses`;
export const UPGRADE_REPORT_API = `${ORCHESTRATION_SERVICE_API}/v1/report`;
export const UPDATE_REPORT_ADDRESS_API = `${ORCHESTRATION_SERVICE_API}/v1/report/:reportId/address`;
export const REPORT_FACETS_API = `${ORCHESTRATION_SERVICE_API}/v1/report/:reportId/facets`;
export const REPORT_IMAGE_FILES_API = `${ORCHESTRATION_SERVICE_API}/v1/report/:reportId/image-files`;
export const REPORT_DETAILS_API = `${ORCHESTRATION_SERVICE_API}/v1/report/:reportId/report-details`;
export const UPDATE_REPORT_PITCH_API = `${ORCHESTRATION_SERVICE_API}/v1/report/:reportId/pitches`;
export const ACCOUNT_SUMMARY_API = `${ORCHESTRATION_SERVICE_API}/v1/account-summary`;
export const ADDRESS_INFORMATION_API = `${ORCHESTRATION_SERVICE_API}/v1/address-information`;
export const IMAGE_AVAILABILITY_API = `${ORCHESTRATION_SERVICE_API}/v1/users/image-availability`;
export const UPLOAD_RESOURCE_FILE_API = `${ORCHESTRATION_SERVICE_API}/v1/resource-file`;
export const DOWNLOAD_CUSTOM_COVER_PREVIEW_API = `${ORCHESTRATION_SERVICE_API}/v1/preferences/cover-page/download-preview`;
export const SAVE_UPLOAD_INFORMATION_API = `${ORCHESTRATION_SERVICE_API}/v1/report/:reportId/blue-print`;
export const ORG_DESCENDANTS_API = `${ORCHESTRATION_SERVICE_API}/v1/organisation/:orgId/descendants`;
export const SRS_CUSTOMER_VALIDATE_API = `${ORCHESTRATION_SERVICE_API}/v1/srs-customer-validate`;
export const TEXT_ALERT_PREFERENCES_API = `${ORCHESTRATION_SERVICE_API}/v1/text-alert-preferences`;
export const TEXT_ALERT_MESSAGES_API = `${ORCHESTRATION_SERVICE_API}/v1/alerts`;
export const MOBILE_PROVIDERS_API = `${ORCHESTRATION_SERVICE_API}/v1/mobile-providers`;
export const NEXT_PLAN_LEVEL_API = `${ORCHESTRATION_SERVICE_API}/v1/nextplanlevel-qualifier`;
export const SUSPEND_PREPAY_API = `${ORCHESTRATION_SERVICE_API}/v1/suspend-prepay`;
export const ACCOUNT_PAYMENT_OPTIONS_API = `${ORCHESTRATION_SERVICE_API}/v1/account-payment-options`;
export const UPDATE_REPORT_TYPE_CHANGE = `${ORCHESTRATION_SERVICE_API}/v1/report/:reportId/report-type-change`;
export const SUBSCRIPTION_DASHBOARD_API = `${ORCHESTRATION_SERVICE_API}/v1/subscription/:orgId`;
export const CONSUMPTION_API = `${ORCHESTRATION_SERVICE_API}/v1/subscription/:orgId/usage-summary/:subscriptionId`;
export const SUBSCRIPTION_DASHBOARD_LEGACY_API = `${ORCHESTRATION_SERVICE_API}/v1/subscription-legacy/:orgId`;
export const SUBSCRIPTION_REPORT_DETAILS_API = `${ORCHESTRATION_SERVICE_API}/v1/subscription/reportDetails`;
export const GET_STATEFARM_DASHBOARD_API = `${ORCHESTRATION_SERVICE_API}/v1/organizations/analytics-dashboard`;

// Property Data APIs
export const PROPERTY_DATA_REQUEST_API = `${ORCHESTRATION_SERVICE_API}/v1/property-data/request`;
export const ORDER_HISTORY_PROPERTY_DATA_API = `${ORCHESTRATION_SERVICE_API}/v1/order-history-property-data`;
export const PROPERTY_DATA_RESULT_API = `${ORCHESTRATION_SERVICE_API}/v1/property-data/result`;
export const PROPERTY_DATA_IMAGE_METADATA_API = `${ORCHESTRATION_SERVICE_API}/imagery/v3/discovery/rank/location`;

// SLA Property Data APIs
export const SLA_PROPERTY_DATA_REQUEST_API = `${ORCHESTRATION_SERVICE_API}/v1/sla-property-data/request`;
export const SLA_PROPERTY_DATA_RESULT_API = `${ORCHESTRATION_SERVICE_API}/v1/sla-property-data/result`;

export const USER_ENTITLEMENTS_API = `${ORCHESTRATION_SERVICE_API}/v1/entitlements`;

/** GET /v1/entitled-thirdparty-apps — user’s entitled third-party integrations */ // #genai
export const ENTITLED_THIRDPARTY_APPS_API = `${ENTITLEMENTS_API}/v1/entitled-thirdparty-apps`;

export const USER_APP_ENTITLEMENTS_API = `${VIEWPOINT_API}/v1/entitlements`;

export const USER_PROFILE_API = `${ACCOUNT_MANAGEMENT_API}/v2/user-profile`;

export const REPORT_ANALYTICS_API = `${ORCHESTRATION_SERVICE_API}/v1/organizations/:orgId/report-analytics`;
export const REPORT_ANALYTICS_COUNT_API = `${ORCHESTRATION_SERVICE_API}/v1/organizations/:orgId/analytics-report-count`;
export const DOWNLOAD_REPORT_ANALYTICS_CSV = `${ORCHESTRATION_SERVICE_API}/v1/organizations/:orgId/report-analytics/export-csv`;

export const SESSIONS_API = `${ORCHESTRATION_SERVICE_API}/v2/sessions/:currencyType`;

export const ACCOUNT_DELETION_API = `${ORCHESTRATION_SERVICE_API}/v1/delete-account`;
export const GET_RESOURCE_FILE_API = `${ORCHESTRATION_SERVICE_API}/v1/resource-file/:fileId`;
export const ACCOUNT_DELETION_EMAIL = 'accountdeletion@eagleview.com';

export const CUSTOMER_SERVICE_EMAIL = 'customerservice@eagleview.com';

export const TYPE_AHEAD_API_SUCCESS_STATUS_CODE = 1107;
export const GEOCODE_API_SUCCESS_STATUS_CODE = 1101;
export const REVERSE_GEOCODE_API_SUCCESS_STATUS_CODE = 1104;

export const LOCALSTATE_HISTORY_KEY = 'myev_search_history';
export const MAX_HISTORY_LENGTH = 5;

export const MATCH_NOT_FOUND = 'Match not found';
export const ADDRESS_SEARCH_PLACEHOLDER = 'Search by address or latitude-longitude';
export const ADDRESS_SEARCH_MAX_LENGTH = 50;

export const PROD_ENV = 'prod';

export const GAINSIGHT_PX_FUNCTION_NAME = 'aptrinsic';

export const STANDALONE_PAGES = [
  ACCOUNT_DELETION_ROUTE,
  DASHBOARD_ROUTE,
  SERVICE_AGREEMENT_ROUTE,
  ACH_AUTHORIZATION_ROUTE, // #genai
  SITEMAP_APPROVAL_ROUTE,
  SITEMAP_SUBMITTED_ROUTE,
];

export const OrderPreferences = 'Order Preferences';
export const BillingInformation = 'Billing Information';
export const ContactInformation = 'Contact Information';
export const Dashboard = 'Dashboard';

export const COUNTRY_LIST = [
  {
    id: 'US',
    description: 'United States',
  },
  {
    id: 'CA',
    description: 'Canada',
  },
  /** {
    id: 'GB',
    description: 'United Kingdom',
  },  */
];

export const COUNTRY_US = 'US';
export const COUNTRY_UK = 'UK';
export const COUNTRY_CA = 'CA';

export const YES = 'Yes';

export const LANGUAGES = [
  { id: 'en', description: 'English' },
  { id: 'fr', description: 'French' },
];

export const STATUSES = {
  Created: 1,
  InProcess: 2,
  Pending: 3,
  Closed: 4,
  Completed: 5,
};

export const DECRYPT_FAILURE_CODE = 5;

export const GET_DUPLICATE_REPORTS_API = `${ORCHESTRATION_SERVICE_API}/v1/duplicate-reports`;
export const GET_DUPLICATE_REPORTS_API_SUCCESS_STATUS_CODE = 200;

export const LATITUDE = 'latitude';
export const LONGITUDE = 'longitude';
export const ADDRESS = 'address';
export const COUNTRY = 'country';

export const PIN_COLORS = [
  '#007CAD',
  '#CC7000',
  '#288301',
  '#A60064',
];

export const FOCUSED_PIN_COLORS = [
  '#82899C', '#82899C', '#82899C', '#82899C',
];

export const ADDRESS_REGEX = /^[\s#.,\-0-9A-Za-z]+$/;
export const ZIP_CODE_US_REGEX = /^\d{5}(?:[-\s]\d{4})?$/;
export const ZIP_CODE_CA_REGEX = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;
export const NO_ANGLE_BRACKETS_REGEX = /^[^<>]*$/;
export const EMAIL_REGEX = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;
export const CARD_REGEX = /^(\d{12,16})$|([*]{8,12}\d{4})$/;
export const PHONE_REGEX = /^\d{3}-\d{3}-\d{4}$/;
export const PHONE_REGEX_WITHOUT_HYPHEN = /^\d{10}$/;
export const EXT_REGEX = /^\d{1,5}$/;
// #genai Cybersource/Stratus ACH company name: first char letter/number/?; remaining type-A
// alphanumeric (spc_online_processing) including space and the listed specials.
export const CYBERSOURCE_COMPANY_NAME_FIRST_CHAR_REGEX = /^[A-Za-z0-9?]/;
export const CYBERSOURCE_COMPANY_NAME_REGEX = /^[A-Za-z0-9?][A-Za-z0-9 !"#$%&'()*+,./:;<=>?@[\\\]^_`{|}~-]*$/;
export const COMPANY_NAME_PHONE_TOKEN_REGEX = /\b(?:\d{3}-\d{3}-\d{4}|\d{10})\b/;
export const COMPANY_NAME_SSN_DASHED_REGEX = /\b\d{3}-\d{2}-\d{4}\b/;
export const COMPANY_NAME_SSN_DIGITS_ONLY_REGEX = /^\d{9}$/;
export const CYBERSOURCE_COMPANY_NAME_ISSUE = {
  EMPTY: 'empty',
  PII: 'pii',
  FIRST_CHAR: 'firstChar',
  CHARSET: 'charset',
  VALID: 'valid',
};

export const CREDIT_CARD_NAMES = {
  1: 'American Express',
  2: 'Visa',
  3: 'MasterCard',
  4: 'Discover',
};
export const ADDRESS_TYPES = {
  BillToAddress: 'BillToAddress',
  ShipToAddress: 'ShipToAddress',
};

export const RESIDENTIAL = 'Residential';
export const COMMERCIAL = 'Commercial';
export const MULTIFAMILY = 'MultiFamily';

export const STRUCTURE_TYPES = { 1: RESIDENTIAL, 2: COMMERCIAL, 3: MULTIFAMILY };

export const MEASUREMENT_REQUEST_TYPE_IDS = {
  PrimaryPlusDetachedGarage: 1, PrimaryStructureOnly: 2, AllStructuresOnParcel: 3, CommercialComplex: 4, Other: 5,
};

export const MEASUREMENT_REQUEST_TYPES = [
  {
    id: MEASUREMENT_REQUEST_TYPE_IDS.PrimaryPlusDetachedGarage,
    name: 'PrimaryPlusDetachedGarage',
    description: 'Primary Structure + Detached Garage',
  },
  {
    id: MEASUREMENT_REQUEST_TYPE_IDS.PrimaryStructureOnly,
    name: 'PrimaryStructureOnly',
    description: 'Primary Structure Only',
  },
  {
    id: MEASUREMENT_REQUEST_TYPE_IDS.AllStructuresOnParcel,
    name: 'AllStructuresOnParcel',
    description: 'All Structures on Parcel',
  },
  {
    id: MEASUREMENT_REQUEST_TYPE_IDS.CommercialComplex,
    name: 'CommercialComplex',
    description: 'Commercial Complex',
  },
  {
    id: MEASUREMENT_REQUEST_TYPE_IDS.Other,
    name: 'Other',
    description: 'Other (please provide instructions)',
  },
];

export const PRODUCT_IDS = {
  PremiumResidential: 1,
  PremiumCommercial: 2,
  StandardResidential: 3,
  ExpressDelivery: 4,
  SameDayDelivery: 5,
  Xactware: 6,
  ThreeHourDelivery: 7,
  RegularDelivery: 8,
  Images: 9,
  ParkingLot: 10,
  EagleViewInformEssentialsPlus: 11,
  EagleViewInformEssentialsPlusforCommercial: 12,
  ClaimsReadyResidential: 13,
  ClaimsReadyCommercial: 14,
  AA2D: 15,
  AA3DResidential: 16,
  SketchOnly: 17,
  AA3DCommercial: 18,
  EagleViewXML: 19,
  InstallerReport: 20,
  CATReadyResidential: 21,
  CATReadyCommercial: 22,
  CATClaimsReadyResidential: 23,
  CATClaimsReadyCommercial: 24,
  EC3DResidential: 25,
  EC3DCommercial: 26,
  EC2DResidential: 27,
  EC2DCommercial: 28,
  PremiumAWResidential: 29,
  PremiumAWCommercial: 30,
  ECPremiumResidential: 31,
  ECPremiumCommercial: 32,
  WallsAddOn: 33,
  PremiumResidentialWallonly: 34,
  PremiumCommercialWallonly: 35,
  FirstChoicePM: 36,
  RiskManagementResidential: 37,
  RiskManagementCommercial: 38,
  Estimate: 39,
  RoofGeometryResidential: 40,
  CarrierEstimate: 41,
  PictometryPremium: 42,
  PictometryStandard: 43,
  QuickSquaresResidential: 44,
  QuickDelivery: 45,
  GutterResidential: 46,
  GutterCommercial: 47,
  DiagramResidential: 48,
  DiagramCommercial: 49,
  QuickSquaresExtendedCoverage: 50,
  WallsLite: 51,
  ChangeDetection: 52,
  QuickSquaresCommercial: 53,
  WallsLiteAddOn: 54,
  QuickSquaresMultiFamily: 55,
  MaterialList: 56,
  BlueprintResidential: 57,
  RevealConditionResidential: 58,
  RevealRiskResidential: 59,
  SunSitePlusResidential: 60,
  SunSitePlusCommercial: 61,
  EagleViewInformAdvanced: 62,
  EagleViewInformAdvancedforCommercial: 63,
  RevealSunSiteResidential: 64,
  RevealSunSiteCommercial: 65,
  OnSiteValidate: 66,
  RMLiteAddOn: 67,
  VirtualAssist: 68,
  MultiStory: 69,
  Harness: 70,
  CancellationFee: 71,
  FullCancellationFee: 72,
  ClaimsAssignmentService: 73,
  RMLite: 74,
  InteriorInspection: 75,
  AdditionalStructureInspection: 76,
  VACancellationAddOn: 77,
  WallsLiteV2: 78,
  WallsLiteV2AddOn: 79,
  AssessDetect: 80,
  XactwareIntegrationFeePayableRoofReports: 81,
  XactwareIntegrationFeePayableWallReports: 82,
  YouFlyInspection: 83,
  BidPerfect: 84,
  ResWallWinDoor: 85,
  ResWallsFKALite: 86,
  ResWallWinDoorAddOn: 87,
  ResWallsFKALiteAddOn: 88,
  MultipleStructures: 89,
  TrueDesignforSales: 90,
  TrueDesignforPlanning: 91,
  AcculynxIntegrationFee: 92,
  AssessView: 93,
  SolarView: 94,
  SolarValue: 95,
  AssessRoofMeasurements: 96,
  XactwareIntegrationFeePayableAssessReports: 97,
  AssessDroneMeasurements: 98,
  WholeHome: 99,
  AssessRoofMeasurementFee: 100,
  AssessDroneMeasurementFee: 101,
  BidPerfectCommercial: 102,
  SymbilityConvenienceFeeRoofReport: 104,
  SymbilityConvenienceFeeWallReport: 105,
  Roof: 106,
  WallWinDoor: 107,
  WallsFKALite: 108,
  Roof2D: 109,
  Bid_Perfect: 110,
  Full_House: 111,
  PropertyData: 112,
  ConvenienceFeePropertyData: 113, // #genai Convenience Fee Property Data (filter exclusion)
  ESX: 114,
};

// #genai Configurable exception list for OH/Analytics product filters.
// Append PRODUCT_IDS.* entries below to hide more PIDs; no filter/util changes needed.
// Delivery products (TPM)
export const PRODUCT_CATALOG_FILTER_DELIVERY_EXCLUSIONS = [
  PRODUCT_IDS.ExpressDelivery, // 4
  PRODUCT_IDS.SameDayDelivery, // 5
  PRODUCT_IDS.ThreeHourDelivery, // 7
  PRODUCT_IDS.RegularDelivery, // 8
  PRODUCT_IDS.QuickDelivery, // 45
];

// #genai Integration / convenience fees (TPM)
export const PRODUCT_CATALOG_FILTER_FEE_EXCLUSIONS = [
  PRODUCT_IDS.XactwareIntegrationFeePayableRoofReports, // 81
  PRODUCT_IDS.XactwareIntegrationFeePayableWallReports, // 82
  PRODUCT_IDS.AcculynxIntegrationFee, // 92
  PRODUCT_IDS.XactwareIntegrationFeePayableAssessReports, // 97
  PRODUCT_IDS.SymbilityConvenienceFeeRoofReport, // 104
  PRODUCT_IDS.SymbilityConvenienceFeeWallReport, // 105
  PRODUCT_IDS.ConvenienceFeePropertyData, // 113
];

// #genai Extendable entries: delivery + fees. Add future TPM exceptions here.
export const PRODUCT_CATALOG_FILTER_EXCLUSION_ENTRIES = [
  ...PRODUCT_CATALOG_FILTER_DELIVERY_EXCLUSIONS,
  ...PRODUCT_CATALOG_FILTER_FEE_EXCLUSIONS,
];

// #genai O(1) lookup Set. ESX kept from prior filter-hide behavior (not part of TPM fee/delivery list).
export const PRODUCT_CATALOG_FILTER_EXCLUDED_IDS = new Set([
  ...PRODUCT_CATALOG_FILTER_EXCLUSION_ENTRIES,
  PRODUCT_IDS.ESX, // 114
]);

export const ESX_PRODUCT_NAME = 'ESX';

export const NEW_UNIFIED_SKUS = [
  PRODUCT_IDS.Roof,
  PRODUCT_IDS.WallWinDoor,
  PRODUCT_IDS.WallsFKALite,
  PRODUCT_IDS.Roof2D,
  PRODUCT_IDS.Bid_Perfect,
  PRODUCT_IDS.Full_House,
];

export const NO_SELECTEDPRODUCTS_VALIDATION = 'NO_SELECTEDPRODUCTS_VALIDATION';
export const COMPLEX_MARKED_VALIDATION = 'COMPLEX_MARKED_VALIDATION';
export const CLOSED_VALIDATION = 'CLOSED_VALIDATION';
export const NO_SELECTEDPIN_VALIDATION = 'NO_SELECTEDPIN_VALIDATION';
export const NO_BLUEPRINTID_VALIDATION = 'NO_BLUEPRINTID_VALIDATION';

export const LABELS_FOR_PRODUCT_AVAILABILITY = [
  'Loading…',
  'Analyzing 2 billion+ EagleView images…',
  'Determining product availability…',
  'Loading products…',
];

export const PROPERTY_DETAILS_MODULE = 'EagleView.PropertyDetail';

export const STATUS_REASON_TYPES = {
  CustomerClosures: 2,
};

export const SUCCESS = 'success';
export const ERROR = 'error';
export const LOADING = 'loading';
export const WARNING = 'warning';
export const INFO = 'info';

export const LS_ENTITLEMENTS_OBJ_KEY = 'myevEntitlements';

export const PORTAL_ACCESS = 'PORTAL_ACCESS';

// EVCore product family: only roof3DToRoof2DOK and fullHouseToRoofOnlyOK substitution questions are visible.
export const PRODUCT_FAMILY_ID_EVCORE = 7;
export const SUBSTITUTION_QUESTIONS_VISIBLE_FOR_EVCORE = ['roof3DToRoof2DOK', 'fullHouseToRoofOnlyOK', 'wallsOnlyToWallsLiteOK'];

export const SUPPORT_US_USERS = 'https://www.eagleview.com/support/';
export const SUPPORT_CANADA_USERS = 'https://eagleview.ca/support/';
export const SUPPORT_UK_USERS = 'ukcustomerservice@eagleview.com';
export const SUPPORT_UK_CALL = '0-800-069-8405';
export const TERMS_US_USER = 'https://eagleview.com/terms';
export const TERMS_CANADA_USER = 'https://eagleview.ca/terms';

export const LEGACY_EV_PORTAL = 'https://www.eagleview.com';

export const LEGACY_PORTAL_LINKS = {
  dashboard: `${LEGACY_PORTAL_URL}/MyEagleView`,
  billingInformation: `${LEGACY_PORTAL_URL}/MyEagleView/BillingInformation.aspx`,
  contactInformation: `${LEGACY_PORTAL_URL}/MyEagleView/ContactInformation.aspx`,
  orderPreferences: `${LEGACY_PORTAL_URL}/MyEagleView/OrderPreferences.aspx`,
  termsOfUse: `${LEGACY_EV_PORTAL}/terms`,
  addressVerification: `${LEGACY_PORTAL_URL}/verifyaddress.aspx?id=`,
  pitchEditor: `${LEGACY_PORTAL_URL}/EditPitches.aspx?ReportId=`,
  upgrade: `${LEGACY_PORTAL_URL}/PropertyDetails.aspx?upgradeReportId=`,
  upload: `${LEGACY_PORTAL_URL}/blueprintInformation.aspx?id=`,
  privacyPolicy: `${LEGACY_EV_PORTAL}/privacy-statement/`,
  textAlert: `${LEGACY_PORTAL_URL}/MyEagleView/TextAlertSettings.aspx`,
  paymentOptions: `${LEGACY_PORTAL_URL}/MyEagleView/managePaymentOptions.aspx`,
  order: `${LEGACY_PORTAL_URL}/Order`,
  pricing: `${LEGACY_EV_PORTAL}/pricing`,
  sitemap: `${LEGACY_PORTAL_URL}/EVSiteMap.aspx?ID=`,
};

// #genai Salesforce External Knowledge: EagleView Ordering Guide (replaces retired "How To - Order Multiple Structures")
export const EAGLEVIEW_ORDERING_GUIDE_HELP = 'https://eagleviewneworg.my.salesforce-sites.com/ExternalKnowledge/?recId=ka0UJ000000BfizYAC&title=Eagleview%20Ordering%20Guide';

export const REPORT_ATTRIBUTE_IDS = {
  emailCC: 24,
  reportAppointmentDate: 118,
  srsAccountNumber: 312,
  srsShipToSequence: 317,
  srsShipToName: 328,
  srsLocationCode: 329,
  hidePriceEntitlement: 490,
};

export const HISTORY_ACTIONS = {
  POP: 'POP',
  PUSH: 'PUSH',
  REPLACE: 'REPLACE',
};

export const ACCOUNT_LEVEL = {
  BRONZE: 'Bronze',
  SILVER: 'Silver',
  GOLD: 'Gold',
  PLATINUM: 'Platinum',
  CUSTOM: 'Custom',
};

export const STATUS_SEVERITY_MAP = {
  Pending: 'info',
  Pass: 'success',
  Fail: 'error',
};

export const COMMENTS_MAX_LENGTH = 1000;

export const CANCEL_ORDER_REASON_MAX_LENGTH = 200;

export const SUCCESS_RESPONSES = {
  SUCCESS_OK: 200,
  SUCCESS_NO_CONTENT: 204,
};

export const CLIENT_ERROR_RESPONSES = {
  STATUS_NOT_FOUND: 404,
  STATUS_UNAUTHORIZED: 403,
  STATUS_CONFLICT: 409,
  STATUS_BAD_REQUEST: 400,
  STATUS_ABORT_REQUEST: 499,
};

export const SERVER_ERROR_RESPONSES = {
  INTERNAL_SERVER_ERROR: 500,
};

export const US_STATES = [
  { name: 'Alabama', abbreviation: 'AL' },
  { name: 'Alaska', abbreviation: 'AK' },
  { name: 'Arizona', abbreviation: 'AZ' },
  { name: 'Arkansas', abbreviation: 'AR' },
  { name: 'California', abbreviation: 'CA' },
  { name: 'Colorado', abbreviation: 'CO' },
  { name: 'Connecticut', abbreviation: 'CT' },
  { name: 'Delaware', abbreviation: 'DE' },
  { name: 'District Of Columbia', abbreviation: 'DC' },
  { name: 'Florida', abbreviation: 'FL' },
  { name: 'Georgia', abbreviation: 'GA' },
  { name: 'Hawaii', abbreviation: 'HI' },
  { name: 'Idaho', abbreviation: 'ID' },
  { name: 'Illinois', abbreviation: 'IL' },
  { name: 'Indiana', abbreviation: 'IN' },
  { name: 'Iowa', abbreviation: 'IA' },
  { name: 'Kansas', abbreviation: 'KS' },
  { name: 'Kentucky', abbreviation: 'KY' },
  { name: 'Louisiana', abbreviation: 'LA' },
  { name: 'Maine', abbreviation: 'ME' },
  { name: 'Maryland', abbreviation: 'MD' },
  { name: 'Massachusetts', abbreviation: 'MA' },
  { name: 'Michigan', abbreviation: 'MI' },
  { name: 'Minnesota', abbreviation: 'MN' },
  { name: 'Mississippi', abbreviation: 'MS' },
  { name: 'Missouri', abbreviation: 'MO' },
  { name: 'Montana', abbreviation: 'MT' },
  { name: 'Nebraska', abbreviation: 'NE' },
  { name: 'Nevada', abbreviation: 'NV' },
  { name: 'New Hampshire', abbreviation: 'NH' },
  { name: 'New Jersey', abbreviation: 'NJ' },
  { name: 'New Mexico', abbreviation: 'NM' },
  { name: 'New York', abbreviation: 'NY' },
  { name: 'North Carolina', abbreviation: 'NC' },
  { name: 'North Dakota', abbreviation: 'ND' },
  { name: 'Ohio', abbreviation: 'OH' },
  { name: 'Oklahoma', abbreviation: 'OK' },
  { name: 'Oregon', abbreviation: 'OR' },
  { name: 'Pennsylvania', abbreviation: 'PA' },
  { name: 'Rhode Island', abbreviation: 'RI' },
  { name: 'South Carolina', abbreviation: 'SC' },
  { name: 'South Dakota', abbreviation: 'SD' },
  { name: 'Tennessee', abbreviation: 'TN' },
  { name: 'Texas', abbreviation: 'TX' },
  { name: 'Utah', abbreviation: 'UT' },
  { name: 'Vermont', abbreviation: 'VT' },
  { name: 'Virginia', abbreviation: 'VA' },
  { name: 'Washington', abbreviation: 'WA' },
  { name: 'West Virginia', abbreviation: 'WV' },
  { name: 'Wisconsin', abbreviation: 'WI' },
  { name: 'Wyoming', abbreviation: 'WY' },
];

export const CANADA_PROVINCES = [
  { name: 'Alberta', abbreviation: 'AB' },
  { name: 'British Columbia', abbreviation: 'BC' },
  { name: 'Manitoba', abbreviation: 'MB' },
  { name: 'New Brunswick', abbreviation: 'NB' },
  { name: 'Newfoundland and Labrador', abbreviation: 'NL' },
  { name: 'Northwest Territories', abbreviation: 'NT' },
  { name: 'Nova Scotia', abbreviation: 'NS' },
  { name: 'Nunavut', abbreviation: 'NU' },
  { name: 'Ontario', abbreviation: 'ON' },
  { name: 'Prince Edward Island', abbreviation: 'PE' },
  { name: 'Quebec', abbreviation: 'QC' },
  { name: 'Saskatchewan', abbreviation: 'SK' },
  { name: 'Yukon', abbreviation: 'YT' },
];

export const PRODUCT_TYPES = {
  NotSet: 0,
  Premium: 1,
  Standard: 2,
  Xactware: 3,
  Images: 4,
  ParkingLot: 5,
  Solar: 6,
  D2: 7,
  D3: 8,
  SketchOnly: 9,
  EagleViewXML: 10,
  InstallerReport: 11,
  CATReady: 12,
  Walls: 13,
  RiskManagement: 14,
  ExpressDelivery: 15,
  RegularDelivery: 16,
  SameDayDelivery: 17,
  ThreeHourDelivery: 18,
  ClaimsReady: 19,
  Estimate: 20,
  RoofGeometry: 21,
  Complete: 22,
  Partial: 23,
  QuickSquares: 24,
  QuickDelivery: 25,
  Gutter: 26,
  Diagram: 27,
  QuickSquaresExtendedCoverage: 28,
  WallsLite: 29,
  Blueprint: 30,
  RevealCondition: 31,
  RevealRisk: 32,
  OnSiteValidate: 33,
  WallsLiteV2: 34,
  ResWallWinDoor: 35,
  ResWallsFKALite: 36,
  BidPerfect: 37,
  WholeHome: 38,
};

export const FILE_TYPES = {
  UserSubmittedReportPhoto: 1,
  Bill: 2,
  Premium: 3,
  Neighborhood: 4,
  Cover: 5,
  TopImage: 6,
  ParkingLot: 7,
  InformEssentialsPlus: 8,
  RiskManagementReport: 9,
  Sketch: 10,
  BOM: 11,
  Owner: 12,
  PreStandard: 13,
  Standard: 14,
  StandardLineDiagram: 15,
  EconomyMetadata: 16,
  ImagesOnly: 17,
  EagleViewXML: 18,
  DefaultCoverTemplate: 19,
  ReportCoverTemplate: 20,
  CustomerLogo: 21,
  NorthImage: 22,
  SouthImage: 23,
  EastImage: 24,
  WestImage: 25,
  AutoCAD: 26,
  AppliCad: 27,
  LengthDiagram: 28,
  NotesDiagram: 29,
  InstallerLengthDiagram: 30,
  PitchDiagram: 31,
  AreaDiagram: 32,
  InstallerMetadata: 33,
  InstallerSalesReport: 34,
  InstallerFieldInspectorReport: 35,
  InstallerSalesReportTemplate: 36,
  InstallerFieldInspectorReportTemplate: 37,
  InstallerReportVendorTemplate: 38,
  XactwareGenericErrorPdf: 39,
  XactwareGenericErrorXml: 40,
  DisputedReportTemplate: 41,
  DetailedLengthDiagram: 42,
  NotesNoLabelDiagram: 43,
  GridDrawingDiagram: 44,
  GridRotatedDrawing: 45,
  OrientationDrawing: 46,
  PitchDegreeDrawing: 47,
  RafterDrawing: 48,
  SkeletonDrawing: 49,
  DDDdrawing: 50,
  ClaimsReadyReport: 51,
  AA3DReport: 52,
  AA2DReport: 53,
  CATReadyMetadata: 54,
  CATReady: 55,
  ReportTemplate: 56,
  PremiumMetadata: 57,
  ClaimsReadyMetadata: 58,
  AA3DMetadata: 59,
  WorkOrder: 60,
  GoogleMapImage: 61,
  RejectEmailAttachment: 62,
  PreAA2D: 63,
  InstallerReport: 64,
  PerimeterDiagram: 65,
  SurfaceAreaDiagram: 66,
  ParkingLotMetadata: 67,
  SunSiteMetadata: 68,
  SketchOnlyReport: 69,
  SketchOnlyMetadata: 70,
  EC3DReport: 71,
  EC3DMetadata: 72,
  EC2DReport: 73,
  EC2DMetadata: 74,
  ECPremiumReport: 75,
  PremiumAWReport: 76,
  VACancellationAddOn: 77,
  AddOnPlaceHolder: 78,
  WallAreaDiagram: 79,
  AlternateWallView: 80,
  MissingWallDiagram: 81,
  NorthElevationDiagram: 82,
  SouthElevationDiagram: 83,
  EastElevationDiagram: 84,
  WestElevationDiagram: 85,
  RoofPenetrationDiag: 86,
  WallsOnlyReport: 87,
  WallsOnlyMetadata: 88,
  RiskManagementMetadata: 89,
  LivingAreaDiagram: 90,
  WallsNoLabelsDiagram: 91,
  AreaViewImage: 92,
  PitchPenetrationDiag: 93,
  BldgFootprintDiagram: 94,
  SiteMapDiagram: 95,
  OutbuildingDiagram: 96,
  AreaViewImageWithParcel: 97,
  RoofGeometryReport: 98,
  RoofGeometryMetadata: 99,
  RoofGeometryDiagram: 100,
  EagleViewEVM: 101,
  EagleViewJSON: 102,
  PictometryLegacyReport: 103,
  InstallerReportVendorValues: 104,
  QuickSquaresReport: 105,
  StructureDiagram: 106,
  EVMeasurementJSON: 107,
  TopImageWithOutline: 108,
  GutterReport: 109,
  EaveDiagram: 110,
  DiagramReport: 111,
  NotesNoLabelWithParcel: 112,
  ParcelDocument: 113,
  DECRAMaterialsSummaryTemplate: 114,
  DECRAMaterialsSummaryValues: 115,
  QuickSquaresECReport: 116,
  BuildingOutlineDiagram: 117,
  EC2DPrePitchReport: 118,
  InitialSaranacJobScreenshot: 119,
  CompletedSaranacJobScreenshot: 120,
  WallsLiteReport: 121,
  SubmittedBlueprint: 122,
  CapturedBlueprintImage: 123,
  MeasurementBlueprintImage: 124,
  MeasurementSummary: 125,
  RevealConditionReport: 126,
  RevealConditionMetaData: 127,
  RevealRiskReport: 128,
  RevealRiskMetadata: 129,
  SunSitePlusReport: 130,
  SunSitePlusMetaData: 131,
  InformAdvanced: 132,
  RevealSunSiteReport: 133,
  OnSiteSummary: 134,
  DroneFlightPathDiagram: 135,
  DronePointDiagram: 136,
  KMLPerimeter: 137,
  KMLSegment: 138,
  KMLFacet: 139,
  KMLWireframe: 140,
  OnSiteValidateReport: 141,
  PropertyInspectionImage: 142,
  WorldFile: 143,
  WorldFileDiagram: 144,
  OnSiteWeatherReport: 145,
  GeoJsonPolygon: 146,
  OmniEarthAutomatedQuickSquaresJson: 147,
  ExternalAreaDiagram: 148,
  ImageMetaData: 149,
  QSPerimeterDiagram: 150,
  WavefrontOBJFile: 151,
  SketchUpFile: 152,
  DDDMeasurementDXFWithIrradience: 153,
  SSC3DModel: 154,
  AnnualIrradienceFile: 155,
  ZippedIrradienceDataFile: 156,
  FisheyeAndDiagrams: 157,
  DroneBaseMissionCreatePreview: 158,
  Povray: 159,
  SunsiteSearchResponse: 160,
  IrradianceDiagram: 161,
  FisheyeDiagram: 162,
  RoofSectionsSummary: 163,
  LabelPlacementFile: 164,
  MonthlySolarAccessData: 165,
  IrradianceDiagramWithDSM: 166,
  BuildingSummary: 167,
  GeomniXactwareSketch: 168,
  CompressedZipFile: 169,
  SoffitTransformedEvJson: 170,
  GLTFTransformedJSON: 171,
  RoofFacetIsolated: 172,
  BidPerfectReport: 173,
  ResWallWinDoor: 174,
  ResWallsFKALite: 175,
  MaskImage: 176,
  EagleViewSummaryXML: 177,
  EVMeasurementSummaryJSON: 178,
  EVMLMeasurementJSON: 179,
  SolarEagleViewJSON: 180,
  SolarHouseModelJSON: 181,
  TrueDesignforPlanning: 182,
  TrueDesignforSales: 183,
  SolarFeasibility: 184,
  SolarFeasibilityJSON: 185,
  SunEagle: 186,
  AISImageMetadataJSON: 187,
  TrueDesignPanelDXF: 188,
  TrueDesignPanelIsolatedDXF: 189,
  FullHouseReport: 190,
  ShadeDataZIP: 191,
  ImageAlignmentOffsetJSON: 192,
  PMFJSON: 193,
  PMSJSON: 194,
  StructureNumberDiagram: 195,
  ExtendedOrthoImage: 196,
  ExtendedOrthoImageMetadata: 197,
  SolarGLTFJSON: 198,
  Roof3D: 199,
  wallWinDoorReport: 200,
  wallsFKALiteReport: 201,
};

export const FILE_FORMATS = {
  JPG: 1,
  JPEG: 1,
  PDF: 2,
  DOC: 3,
  XML: 4,
  DXF: 5,
  RXF: 6,
  XLS: 7,
  HTML: 8,
  EMF: 9,
  PNG: 10,
  GIF: 11,
  EPS: 12,
  DOCX: 13,
  DOT: 14,
  DOTX: 15,
  XLSX: 16,
  EVM: 17,
  JSON: 18,
  ZIPJPGS: 19,
  KML: 20,
  EVA: 21,
  OBJ: 22,
  SKP: 23,
  ZIP: 24,
  CSV: 25,
  ESX: 26,
};

export const BillingType = {
  TERMS: 'Terms',
  CREDIT_CARD: 'CreditCard',
  ACCOUNT: 'Account',
  FREE: 'Free',
  NO_CHARGE: 'NoCharge',
  SPLIT_CHARGE: 'SplitCharge',
  PROMO: 'Promo',
  BUNDLE_DISCOUNT: 'BundleDiscount',
  DISTRIBUTOR_THD: 'DistributorTHD',
  UPGRADE_DISCOUNT: 'UpgradeDiscount',
  DECRA_DISCOUNT: 'DecraDiscount',
  MSO_FREE_SMALL_STRUCTURE: 'MsoFreeSmallStructure',
  ENTEGRA_DISCOUNT: 'EntegraDiscount',
};

export const NOTIFICATION_BAR_STATES = {
  IDLE: 1,
  PROGRESS: 2,
  SUCCESS: 3,
  ERROR: 4,
  CLOSE: 5,
};

export const CURRENCY_SYMBOL = {
  1: '$',
  2: '$',
  3: '&pound;',
  4: 'C $',
};

export const CURRENCY_TYPE = {
  2: 'USD',
  4: 'CAD',
};

export const CUSTOM_COVER_DEFAULT_LAYOUT = 1;

export const ABORT_ERROR = 'AbortError';

export const INGREDIENTS = {
  HIDE_PRICING: 'HIDE_PRICING',
  ALLOW_UPGRADE: 'ALLOW_UPGRADE',
  IMAGE_AVAILABILITY: 'IMAGE_AVAILABILITY',
  DISABLE_ORDERING: 'DISABLE_ORDERING',
  ENABLE_ACH: 'ENABLE_ACH', // #genai
  ANALYTICS: 'ANALYTICS',
  GLOBAL_SEARCH: 'GLOBAL_SEARCH',
  SUBSCRIPTION_DASHBOARD: 'SUBSCRIPTION_DASHBOARD',
  PROPERTY_DATA_PRE_INSPECTION: 'PROPERTY_DATA_PRE_INSPECTION',
  EMBEDDED_VIEWER: 'EMBEDDED_VIEWER',
  SUBSCRIPTION_DASHBOARD_V2: 'SUBSCRIPTION_DASHBOARD_V2',
};

export const TRUE_DESIGN_APP_CODE = 'truedesign';
export const PROPERTY_VIEWER_APP_CODE = 'property';

export const HIDDEN_APPS = [TRUE_DESIGN_APP_CODE, PROPERTY_VIEWER_APP_CODE];
export const USER_EVENTS = {
  SAVE_ORDER_PREFERENCES: 'Save Order Preferences',
  SAVE_TEXT_ALERT_PREFERENCES: 'Save Text Alert Preferences',
  PLACE_ORDER: 'Place Order',
  SAVE_BILLING_INFO: 'Save Billing Info',
  SAVE_CONTACT_INFO: 'Save Contact Info',
  UPGRADE_ORDER: 'Upgrade Order',
  SAVE_PITCH: 'Save Pitch',
  VERIFY_ADDRESS: 'Verify Address',
  CANCEL_ORDER: 'Cancel Order',
  UPLOAD_BLUEPRINT: 'Upload Blueprint',
};

// eslint-disable-next-line no-console
console.log('MyEV UI Version: ', VERSION);
